<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import WideLayout from "@/layouts/WideLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import { useUserStorage } from '@/modules/f8/hooks';

const userStorage = useUserStorage();
const route = useRoute();

const layoutComponent = computed(() => {
  if (route.meta.layout === "empty") {
    return EmptyLayout;
  }

  if (route.meta.layout === "wide") {
    return WideLayout;
  }
  
  return MainLayout;
});

onMounted(() => {
  // Load theme on page load
  document.body.classList.add(userStorage.get('cfgTheme', 'light'));
})


</script>

<style lang="scss">
@import "assets/styles/reset.scss";
@import "assets/styles/grid.scss";
@import "assets/styles/buttons.scss";
@import "assets/styles/controls.scss";
@import "assets/styles/modal.scss";
@import "assets/styles/elements.scss";
@import "assets/styles/utilities.scss";
@import "assets/styles/icons.scss";
@import "assets/styles/loader.scss";

@import "assets/styles/all.scss";
</style>